import { removeCookie, setCookie } from '@utils/cookie';

export const userLogin = (token: string) => {
    setCookie('HMT', token);
    window.location.href = '/main';
};

export const userLogout = () => {
    removeCookie('HMT');
    window.location.href = '/auth/login';
};
